import Reveal from "./Reveal";
import { CARRIERS } from "../data/content";

export default function Carriers() {
  const doubled = [...CARRIERS, ...CARRIERS];
  return (
    <section id="carriers" data-testid="carriers-section" className="relative py-10 lg:py-14 overflow-hidden">
      <div className="max-w-6xl mx-auto px-5 text-center">
        <Reveal>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-white">
            Choose <span className="breeze-text">Breeze Financial</span>
          </h2>
          <p className="mt-3 text-sm sm:text-base text-slate-400">
            Superb Systems, Top 1% Leadership, A-Rated Carriers
          </p>
        </Reveal>
      </div>
      <Reveal delay={0.15} className="mt-10">
        <div className="relative" data-testid="carrier-marquee">
          <div className="pointer-events-none absolute inset-y-0 left-0 w-24 z-10 bg-gradient-to-r from-[#030712] to-transparent" />
          <div className="pointer-events-none absolute inset-y-0 right-0 w-24 z-10 bg-gradient-to-l from-[#030712] to-transparent" />
          <div className="overflow-hidden py-2">
            <div className="marquee-track flex w-max items-center gap-5 px-5">
              {doubled.map((c, i) => (
                <div
                  key={`${c.name}-${i}`}
                  className="glass-card rounded-2xl h-20 w-44 shrink-0 flex items-center justify-center px-6 hover:border-sky-400/40 transition-colors duration-300"
                >
                  <img
                    src={c.logo}
                    alt={c.name}
                    loading="lazy"
                    className="max-h-10 max-w-[130px] object-contain opacity-80 hover:opacity-100 transition-opacity duration-300 brightness-0 invert"
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </Reveal>
    </section>
  );
}
